import { isTouchDevice, keys, $doc } from './utils'

export default function navigationUI() {
	const $nav = $('.navigation');
	const $linkHolders = $('.js-nav-link-holder');
	const $backButtons = $('.js-navigation-back');

	$nav.on('show.bs.modal', function() {
		$('body').addClass('navigation-open');

		$nav.find('a').first().focus();
	}).on('hide.bs.modal', function() {
		$('body').removeClass('navigation-open');

		resetMenu();
	});

	$linkHolders.on('mouseenter click', function() {
		const $this = $(this);

		showMenu($this);
	});

	$linkHolders.on('mouseleave', function() {
		const $this = $(this);

		hideMenu($this);
	});

	$linkHolders.children('a').on('click', function(event) {
		const $this = $(this);

		if ( isTouchDevice() ) {
			if (!$this.hasClass('clicked')) {
				event.preventDefault();

				$this.addClass('clicked');
			}
		}
	});

	$backButtons.on('click', function(event) {
		event.stopPropagation();

		const $holder = $(this).closest('.js-nav-link-holder');

		hideMenu($holder);
	});

	$doc.on('keydown', function(event) {
		if (event.keyCode === keys.escape) {
			$nav.modal('hide')
		}
	})

	function showMenu($el) {
		$el.children().addClass('active');
		$el.siblings().children().removeClass('active clicked');
		$el.closest('.js-nav-links-container').addClass('hovered');

		const levelLink = $el.children('a');
		$('.level-text').text(levelLink.text());
		$('.level-text').attr('href', levelLink.attr('href'));
	}

	function hideMenu($el) {
		$el.children().removeClass('active clicked');
		$el.closest('.js-nav-links-container').removeClass('hovered');
	}

	function resetMenu() {
		$linkHolders.each(function() {
			hideMenu($(this));
		});

		$nav.find('.clicked').removeClass('clicked')
	}
}
